import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/userStore'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Version Signal for Deployment Verification
console.log(`[Apolaki] Bootstrapping - Build Time: ${new Date().toISOString()}`)
console.log('[Apolaki] Applied: Asset CDN, Single-Trip Auth, Synchronous Interceptors')

// Mount immediately for better TTI/FCP
app.mount('#app')

// Restore session in background
const userStore = useUserStore()
userStore.restoreSession().catch(error => {
  console.warn('[Bootstrap] Background session restoration failed:', error)
})
